import { Modal, Box } from "@mui/material";
import warning from "../../../assets/warning.svg";
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const InviteSetupModal = ({ open, onClose, type, onContinue }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isPassword = type === "password";
  const translationKey = isPassword
    ? "inviteSetupModal.password"
    : "inviteSetupModal.profile";

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "calc(100% - 32px)", sm: 450 },
          bgcolor: "white",
          p: 3,
          borderRadius: 2,
          textAlign: "center",
          boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
        }}
      >
        <img src={warning} style={{ width: 90, height: 90 }} alt="warning" />
        <CustomText
          sx={{
            ...textStyles,
            fontSize: "24px",
            fontWeight: 500,
            fontFamily: "Poppins, sans-serif",
            color: theme.palette.tertiary.main,
            mb: 2,
            mt: 1,
          }}
        >
          {t(`${translationKey}.title`)}
        </CustomText>
        <CustomText
          sx={{ ...textStyles.body4, color: theme.palette.text.primary, mb: 3 }}
        >
          {t(`${translationKey}.description`)}
        </CustomText>
        <CustomButton
          label={t(`${translationKey}.continue`)}
          fullWidth
          onClick={onContinue}
        />
      </Box>
    </Modal>
  );
};

export default InviteSetupModal;